import UserDealerListResponse, {
  UserDealerListResponseItem,
} from "../../../../api/raily/user/dealer/list/user-dealer-list.response";
import UserDealerList, { UserDealerListItem } from "./user-dealer-list";

const createAlternativePhoneNumber = (
  responseDataItem: UserDealerListResponseItem,
): UserDealerListItem["alternativePhoneNumber"] => {
  if (
    !responseDataItem.mobileSecondary ||
    !responseDataItem.mobileSecondaryPrefix
  ) {
    return null;
  }

  return {
    dialingCode: responseDataItem.mobileSecondaryPrefix,
    number: responseDataItem.mobileSecondary,
  };
};

const createPhoneNumber = (
  responseDataItem: UserDealerListResponseItem,
): UserDealerListItem["phoneNumber"] => {
  return {
    dialingCode: responseDataItem.mobilePrimaryPrefix,
    number: responseDataItem.mobilePrimary,
  };
};

const createDataItem = (
  responseDataItem: UserDealerListResponseItem,
): UserDealerListItem => {
  return {
    removalDate: responseDataItem.removedAt,
    uuid: responseDataItem.id,
    firstName: responseDataItem.firstName,
    lastName: responseDataItem.lastName,
    email: responseDataItem.email,
    username: responseDataItem.username,
    phoneNumber: createPhoneNumber(responseDataItem),
    alternativePhoneNumber: createAlternativePhoneNumber(responseDataItem),
    taxiCorporationName: responseDataItem.dealer.taxiCorporation.companyName,
  };
};

const createData = (
  responseData: UserDealerListResponseItem[],
): UserDealerListItem[] => {
  return responseData.map(createDataItem);
};

const create = (response: UserDealerListResponse): UserDealerList => {
  return {
    data: createData(response.data.data),
    totalCount: response.data.totalCount,
  };
};

const userDealerListFactory = {
  create,
};

export default userDealerListFactory;
